import { FormControl, FormGroup, Validators } from '@angular/forms';

export class NickForm extends FormGroup {
  constructor() {
    super({
      nick: new FormControl('', [Validators.minLength(2), Validators.maxLength(20)]),
    });
  }

  get nick(): FormControl {
    return this.get('nick') as FormControl;
  }

}
